module.exports = __webpack_public_path__ + "static/img/work3.3c37e0b9.png";